// MD2 PRO
import MDBox from 'components/MDBox';
import Card from '@mui/material/Card';
import FileViewGoogleDrive from 'components/General/File/FileViewGoogleDrive';

import ContractDetail from 'layouts/production/Components/AaroComponents/ContractDetail';
// Constants
import { config } from 'Constants';

const { GOOGLE_DRIVE_CONTRACT_FILES_FOLDER_ID } = config.fixedID;
function AaroContractRightArea({ production, aaroQueries }) {
    const { contractQuery } = aaroQueries;
    const contractDetails = contractQuery?.data?.[0] || {};

    const { SozlesmeID: SozlesmeIDContract } = contractDetails;

    // Ensure production object exists to prevent errors
    if (!production) {
        return null;
    }
    // Helper function to render contract files section
    const renderContractFiles = () => {
        if (!SozlesmeIDContract) return null;

        return (
            <FileViewGoogleDrive
                folderId={GOOGLE_DRIVE_CONTRACT_FILES_FOLDER_ID}
                getOrCreate={true}
                getOrCreateFolderName={SozlesmeIDContract}
                documents={['01_Kabul Edilen Teklif', '02_Satış Sözleşmeleri', '03_Diğer Belgeler']}
                topName={'Sözleşme Dosyaları'}
            />
        );
    };

    return (
        <>
            <MDBox mb={2}>
                <ContractDetail aaroQueries={aaroQueries} />
            </MDBox>
            <MDBox mb={2}>{renderContractFiles()}</MDBox>
        </>
    );
}

export default AaroContractRightArea;
